import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  selectedRole: {},
  roles: [],
  privileges: [],
  rolesCount: 0,
}

const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    updateSelectedRole: (state, action) => {
      state.selectedRole = action.payload || {}
    },
    updateRoles: (state, action) => {
      state.roles = action.payload || []
    },
    updatePriviliges: (state, action) => {
      state.privileges = action.payload || []
    },
    updateRolesCount: (state, action) => {
      state.rolesCount = action.payload || 0
    },
  },
})

export const { updateSelectedRole, updatePriviliges, updateRoles, updateRolesCount } = roleSlice.actions

export default roleSlice.reducer
